import DesktopDocumentUploadsHistory from './DesktopDocumentUploadsHistory';
import MobileDocumentUploadsHistory from './MobileDocumentUploadsHistory';
import useFormat from '../../../../hooks/useFormat';
import { WidgetComponentProps } from '../../../../types/widget';

const DocumentUploadsHistory = (props: WidgetComponentProps) => {
	const { isMobileFormat } = useFormat();

	return isMobileFormat ? <MobileDocumentUploadsHistory /> : <DesktopDocumentUploadsHistory {...props} />;
};

export default DocumentUploadsHistory;
